import DescriptionList from 'ant-design-pro/lib/DescriptionList';
import Description from 'ant-design-pro/lib/DescriptionList/Description';
import PageHeader from 'ant-design-pro/lib/PageHeader';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Empty,
  Form,
  Icon,
  Input,
  List,
  message,
  Modal,
  Pagination,
  Popconfirm,
  Row,
  Table,
  Upload,
} from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { FormEvent, useState } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as xlsx from 'xlsx';

import { client } from '../../services/api';
import { DateRange } from '../../types/base';
import { GRedpackTemplate, RedpackSendStatus, WECHAT_REDPACK_SEND_STATUS } from '../../types/redpack';

const QUERY_EXPORT_REDPACK_TEMPLATES = gql`
  query Redpack_Templates($ids: [ID], $mobile: String, $take: Int, $skip: Int, $sendRange: DateRange) {
    redpackTemplates(ids: $ids) {
      name
      redpacksConnection(mobile: $mobile, sendRange: $sendRange, take: $take, skip: $skip) {
        nodes {
          id
          userId
          sendStatus
          createdAt
          amount
          user {
            id
            name
          }
        }
      }
    }
  }
`;

const QUERY_REDPACK_TEMPLATES = gql`
  query Redpack_Templates(
    $ids: [ID]
    $mobile: String
    $sendRange: DateRange
    $take: Int
    $skip: Int
    $after: ID
    $before: ID
  ) {
    redpackTemplates(ids: $ids) {
      id
      name
      description
      minAmount
      maxAmount
      receiveLimit
      totalAmountLimit
      redpacksConnection(
        mobile: $mobile
        sendRange: $sendRange
        take: $take
        skip: $skip
        after: $after
        before: $before
      ) {
        nodes {
          id
          userId
          sendStatus
          createdAt
          amount
          user {
            id
            name
          }
        }
        pageInfo {
          totalCount
          startCursor
          endCursor
        }
      }
    }
  }
`;

const MUTATION_SEND_REDPACK = gql`
  mutation sendNormalRedpack($userIds: [ID]!, $redpackTemplateName: String!, $content: RedPackContentInput!) {
    sendNormalRedpack(userIds: $userIds, redpackTemplateName: $redpackTemplateName, content: $content)
  }
`;

const MUTATION_RESEND_REDPACK = gql`
  mutation resendNormalRedpack($id: ID!) {
    resendNormalRedpack(id: $id) {
      id
      userId
      sendStatus
      createdAt
      amount
      user {
        id
        name
      }
    }
  }
`;

export const RedpackDetail = (props: RouteComponentProps<{ id: string }>) => {
  const { id: templateId } = props.match.params;

  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [userIds, setUserIds] = useState<string[]>([]);

  const [redPackContentActName, setRedPackContentActName] = useState('');
  const [redPackContentRemark, setRedPackContentRemark] = useState('');
  const [redPackContentWishing, setRedPackContentWishing] = useState('');

  const [currentPage, setCurrentPage] = useState(1);

  const REDPACKS_COUNT_PER_PAGE = 10;
  const [redPackContentUserMobile, setRedPackContentUserMobile] = useState('');
  const [redPackContentSendRange, setRedPackContentSendRange] = useState<DateRange | undefined>(undefined);
  const [redpacksConnectionVariables, setRedpacksConnectionVariables] = useState<{
    mobile: string;
    sendRange?: DateRange;
    take: number;
    skip?: number;
    before?: number;
    after?: number;
  }>({
    mobile: '',
    skip: 0,
    take: REDPACKS_COUNT_PER_PAGE,
  });

  const onSendClick = () => {
    if (!fileList.length) {
      message.warning('请选择文件！');
      return;
    }
    if (!redPackContentActName) {
      message.warning('actName不能为空！');
      return;
    }
    if (!redPackContentRemark) {
      message.warning('remark不能为空！');
      return;
    }
    if (!redPackContentWishing) {
      message.warning('wishing不能为空！');
      return;
    }
    setIsConfirmVisible(true);
  };

  const onCancelSendClick = () => {
    setIsConfirmVisible(false);
  };

  const uploadProps = () => {
    const uploadProps = {
      beforeUpload: (file: UploadFile | Blob) => {
        const oneFile = file as UploadFile;
        if (oneFile.status !== 'removed') {
          const fileList = [oneFile];
          setFileList(fileList);

          const reader = new FileReader();
          const blob = file as Blob;
          reader.readAsBinaryString(blob);
          reader.onload = (event: any) => {
            const data = event.target.result;
            const workbook = xlsx.read(data, {
              type: 'binary',
            });
            const sheetName = workbook.SheetNames[workbook.SheetNames.length - 1];
            if (!sheetName) {
              return;
            }
            const userIdObjList: { userId: string }[] = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName]) || [];

            const userIdList = userIdObjList.reduce((accumulator, currentValue) => {
              const { userId } = currentValue;
              if (!window.isNaN(Number(userId))) {
                accumulator.push(currentValue.userId);
              }
              return accumulator;
            }, [] as string[]);

            setUserIds(userIdList);
          };
        }
        return false;
      },
      onRemove: () => {
        setFileList([]);
        setUserIds([]);
      },
    };

    return uploadProps;
  };

  const search = (e: FormEvent) => {
    setRedpacksConnectionVariables({
      mobile: redPackContentUserMobile,
      sendRange: redPackContentSendRange,
      skip: 0,
      take: REDPACKS_COUNT_PER_PAGE,
    });

    setCurrentPage(1);

    e.preventDefault();
  };

  const exportExcel = async () => {
    try {
      const response = await client.query<{ redpackTemplates: GRedpackTemplate[] }>({
        query: QUERY_EXPORT_REDPACK_TEMPLATES,
        // templateId转为Number，解决同样api的query组件在exportExcel时再次刷新问题
        variables: {
          ids: [Number(templateId)],
          mobile: redPackContentUserMobile,
          sendRange: redPackContentSendRange,
          skip: 0,
          take: 10000,
        },
      });
      if (!response.data) return;
      message.info('导出红包记录条数最多10000条');

      const { redpackTemplates } = response.data;
      const [redpackTemple] = redpackTemplates;
      const { redpacksConnection, name } = redpackTemple;
      if (!redpacksConnection || !redpacksConnection.nodes) return;

      const redpacks: object[] = [];
      for (const redpack of redpacksConnection.nodes) {
        redpacks.push({
          id: redpack.id,
          sendStatus: WECHAT_REDPACK_SEND_STATUS[redpack.sendStatus],
          sendTime: redpack.createdAt,
          amount: `${Number(redpack.amount) / 100} 元`,
          userName: redpack.user && redpack.user.name,
        });
      }
      const workbook = xlsx.utils.book_new();
      const sheet1 = xlsx.utils.json_to_sheet(redpacks);
      xlsx.utils.book_append_sheet(workbook, sheet1);
      xlsx.writeFile(workbook, `${name}-红包发送记录.xlsx`);
    } catch (error) {
      message.error(`Error! ${error}`);
    }
  };

  const Redpacktemplates = () => (
    <Query<{ redpackTemplates: GRedpackTemplate[] }>
      query={QUERY_REDPACK_TEMPLATES}
      variables={{ ids: [templateId], ...redpacksConnectionVariables }}
    >
      {({ loading, error, data, refetch }) => {
        if (loading) return null;
        if (error) return `Error! ${error}`;
        // @ts-ignore
        if (!data) return <Empty />;

        const { redpackTemplates } = data;
        const [redpackTemple] = redpackTemplates;
        const { redpacksConnection } = redpackTemple;
        return (
          <>
            <PageHeader
              title="红包template信息"
              content={
                <DescriptionList title={redpackTemple.name}>
                  <Description term="名称">{redpackTemple.name}</Description>
                  <Description term="描述">{redpackTemple.description}</Description>
                  <Description term="最小金额">{Number(redpackTemple.minAmount) / 100}元</Description>
                  <Description term="最大金额">{Number(redpackTemple.maxAmount) / 100}元</Description>
                  <Description term="领取限制">{redpackTemple.receiveLimit}次</Description>
                  <Description term="总数限制">{redpackTemple.totalAmountLimit}元</Description>
                </DescriptionList>
              }
            />
            <PageHeader
              title="发送红包"
              content={
                <>
                  <Row gutter={24}>
                    <Col span={8}>
                      <Input
                        placeholder="actName"
                        onChange={e => {
                          setRedPackContentActName(e.target.value);
                        }}
                      />
                    </Col>
                    <Col span={8}>
                      <Input
                        placeholder="remark"
                        onChange={e => {
                          setRedPackContentRemark(e.target.value);
                        }}
                      />
                    </Col>
                    <Col span={8}>
                      <Input
                        placeholder="wishing"
                        onChange={e => {
                          setRedPackContentWishing(e.target.value);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row gutter={24} style={{ marginTop: '20px' }}>
                    <Col span={8}>
                      <Upload {...uploadProps()} accept=".xls, .xlsx" fileList={fileList} multiple={false}>
                        <Button>
                          <Icon type="upload" /> 选择文件
                        </Button>
                      </Upload>
                    </Col>
                    <Col span={8}>
                      <Button type="primary" onClick={onSendClick}>
                        发送 <Icon type="check" />
                      </Button>
                    </Col>
                  </Row>
                </>
              }
            />

            <Mutation
              mutation={MUTATION_SEND_REDPACK}
              variables={{
                userIds,
                redpackTemplateName: redpackTemple.name,
                content: {
                  actName: redPackContentActName,
                  remark: redPackContentRemark,
                  wishing: redPackContentWishing,
                },
              }}
            >
              {sendRedpacks => {
                return (
                  <Modal
                    title="发送列表"
                    visible={isConfirmVisible}
                    onOk={async () => {
                      try {
                        await sendRedpacks();
                        setIsConfirmVisible(false);
                        message.success('发送成功！');
                      } catch (error) {
                        message.error(error.message);
                      } finally {
                        await refetch();
                      }
                    }}
                    onCancel={onCancelSendClick}
                  >
                    <List
                      style={{ overflow: 'auto', height: '600px' }}
                      header={
                        <div>
                          <span style={{ color: 'red' }}>
                            共{userIds.length}个,总金额:{(userIds.length * redpackTemple.maxAmount) / 100} 元。
                          </span>
                          userId发送列表:
                        </div>
                      }
                      bordered
                      dataSource={userIds}
                      renderItem={item => <List.Item>{item}</List.Item>}
                    />
                  </Modal>
                );
              }}
            </Mutation>

            <PageHeader
              title="红包发送记录"
              content={
                <>
                  <Card>
                    <Form onSubmit={search}>
                      <Row gutter={24} type={'flex'} align={'middle'}>
                        <Col span={8}>
                          <Form.Item label={`用户手机号:`}>
                            <Input
                              allowClear
                              placeholder="请输入手机号"
                              value={redPackContentUserMobile}
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setRedPackContentUserMobile(e.target.value);
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={`时间:`}>
                            <DatePicker.RangePicker
                              value={
                                redPackContentSendRange && [
                                  moment(redPackContentSendRange.from).startOf('day'),
                                  moment(redPackContentSendRange.to).endOf('day'),
                                ]
                              }
                              ranges={{
                                今天: [moment().startOf('day'), moment().endOf('day')],
                                本周: [moment().startOf('week'), moment().endOf('week')],
                                上周: [
                                  moment().startOf('week').subtract(1, 'week'),
                                  moment().endOf('week').subtract(1, 'week'),
                                ],
                              }}
                              onChange={dates => {
                                setRedPackContentSendRange({
                                  from: moment(dates[0]).startOf('day').toDate(),
                                  to: moment(dates[1]).endOf('day').toDate(),
                                });
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8} style={{ textAlign: 'right' }}>
                          <Button icon="search" type="primary" style={{ marginRight: 8 }} htmlType="submit">
                            搜索
                          </Button>
                          <Button
                            style={{ marginRight: 8 }}
                            type="primary"
                            onClick={() => {
                              setRedPackContentUserMobile('');
                              setRedPackContentSendRange(undefined);
                            }}
                          >
                            重置
                          </Button>
                          <Button
                            type="primary"
                            icon="download"
                            onClick={async () => {
                              await exportExcel();
                            }}
                          >
                            导出
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Card>
                  <Table
                    rowKey="id"
                    pagination={false}
                    dataSource={redpacksConnection.nodes.filter(redpack => redpack.user)}
                    footer={() => (
                      <div>
                        <Pagination
                          total={redpacksConnection.pageInfo.totalCount}
                          pageSize={redpacksConnectionVariables.take}
                          current={currentPage}
                          onChange={nextPage => {
                            const pageSkip = (Math.abs(nextPage - currentPage) - 1) * REDPACKS_COUNT_PER_PAGE;

                            if (nextPage > currentPage) {
                              setRedpacksConnectionVariables({
                                mobile: redPackContentUserMobile,
                                sendRange: redPackContentSendRange,
                                skip: pageSkip,
                                take: REDPACKS_COUNT_PER_PAGE,
                                after: redpacksConnection.pageInfo.endCursor,
                              });
                            }
                            if (nextPage < currentPage) {
                              setRedpacksConnectionVariables({
                                mobile: redPackContentUserMobile,
                                sendRange: redPackContentSendRange,
                                skip: pageSkip,
                                take: REDPACKS_COUNT_PER_PAGE,
                                before: redpacksConnection.pageInfo.startCursor,
                              });
                            }
                            setCurrentPage(nextPage);
                          }}
                        />
                      </div>
                    )}
                  >
                    <Table.Column key="id" dataIndex="id" title="id" />
                    <Table.Column
                      key="user-name"
                      dataIndex="user"
                      title="用户名"
                      render={user => {
                        return <Link to={`/user/${user.id}`}>{user.name}</Link>;
                      }}
                    />
                    <Table.Column
                      key="amount"
                      dataIndex="amount"
                      title="金额"
                      render={amount => `${Number(amount) / 100} 元`}
                    />
                    <Table.Column
                      key="sendStatus"
                      dataIndex="sendStatus"
                      title="发送状态"
                      render={sendStatus => {
                        return WECHAT_REDPACK_SEND_STATUS[sendStatus];
                      }}
                    />
                    <Table.Column key="createdAt" dataIndex="createdAt" title="发送时间" />
                    <Table.Column
                      title="操作"
                      key="action"
                      render={row => (
                        <>
                          {[RedpackSendStatus.FAILED, RedpackSendStatus.REFUND].includes(row.sendStatus) && (
                            <Mutation
                              mutation={MUTATION_RESEND_REDPACK}
                              variables={{
                                id: row.id,
                              }}
                            >
                              {(resendRedpack, { loading, error }) => {
                                return (
                                  <Popconfirm
                                    title="你确定要重新发送此红包吗？"
                                    icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
                                    onConfirm={async () => {
                                      await resendRedpack();
                                      message.success('红包重新发送成功！');
                                    }}
                                    okText="确定"
                                    cancelText="取消"
                                  >
                                    <Button loading={loading}>重新发送</Button>
                                    {error && <p style={{ color: 'red' }}>{error.message}</p>}
                                  </Popconfirm>
                                );
                              }}
                            </Mutation>
                          )}
                        </>
                      )}
                    />
                  </Table>
                </>
              }
            />
          </>
        );
      }}
    </Query>
  );

  return (
    <>
      <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
        <Breadcrumb.Item>
          <Link to={`/Home`}>首页</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/redpack/list`}>红包列表</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>{Redpacktemplates()}</Card>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/screens/redpack/RedpackDetail.tsx